<script setup lang="ts">
import {DropdownMenuTrigger, type DropdownMenuTriggerProps, useForwardProps} from 'radix-vue'

const props = defineProps<DropdownMenuTriggerProps>()

const forwardedProps = useForwardProps(props)
</script>

<template>
    <DropdownMenuTrigger class="outline-none hover:text-primary active:text-primary transition-colors duration-200"
                         v-bind="forwardedProps">
        <slot/>
    </DropdownMenuTrigger>
</template>
